<template>
  <div class="media_info_wrapper">
    <icon-image :iconUrl="media.ownerStreamer.iconUrl" />
    <div class="media_info_content">
      <div class="media_info">
        <p class="media_info_nickname">
          {{ media.ownerStreamer.nickname }}
        </p>
        <p class="media_info_count">
          <img src="/img/view.png" />{{ media.watchCount }}
        </p>
        <p class="media_info_count">
          <img src="/img/heart.png" />{{ media.likes }}
        </p>
      </div>

      <div class="media_info">
        <img src="/img/share.png" @click="onIconClick" />
        <follow-button
          :targetVliveId="media.ownerStreamer.vliveId"
          :isFollowing="isFollowing"
          @followStateChanged="onFollowStateChanged"
          class="follow_button"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import IconImage from '@/components/IconImage.vue'
import FollowButton from '@/components/FollowButton.vue'
import type * as models from '@/models'

@Component({
  components: {
    IconImage,
    FollowButton,
  },
})
export default class MediaInfo extends Vue {
  @Prop()
  media!: models.Media

  @Prop()
  isFollowing!: boolean

  @Emit('followStateChanged')
  onFollowStateChanged(value: boolean) {
    return value
  }

  @Emit('iconClick')
  onIconClick() {}
}
</script>

<style scoped>
.media_info_wrapper {
  display: flex;
  align-content: center;
}

.media_info_content {
  margin: 0 0 0 8px;
}

.media_info {
  display: flex;
  align-items: center;
  align-content: center;
  margin: 0 0 8px 0;
}

.media_info img {
  max-height: 24px;
}

.media_info_nickname {
  max-width: 150px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media_info_count {
  height: 12px;
  line-height: 12px;
  font-size: 10px;
  margin: 0 0 0 12px;
  color: #ffffff;
}

.media_info_count img {
  height: 12px;
  vertical-align: top;
}

.follow_button {
  margin: 0 0 0 12px;
}
</style>
